import { useEffect, useState } from "react";
import APIService from "services/ApiService";
import { ApiKeyStatus } from "reducers/types";

// Which provider API keys the server has loaded (GET /admin/resources/api-keys), fetched once.
// null while loading or when the request fails: callers then leave their controls enabled,
// the server refuses a start without the key anyway.
const useApiKeyStatus = (): ApiKeyStatus | null => {
  const [status, setStatus] = useState<ApiKeyStatus | null>(null);

  useEffect(() => {
    let active = true;
    new APIService()
      .get("/admin/resources/api-keys")
      .then((res: any) => {
        if (active && res && res.result) {
          setStatus(res.result as ApiKeyStatus);
        }
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, []);

  return status;
};

export default useApiKeyStatus;
